


















































import _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { INotificationMessage } from '@/interfaces';
import { dateService, httpService } from '@/services';
import { i18nMixin } from '@/modules/neodash/mixins';

import { AUTH_GET_TOKEN, AUTH_GET_USERNAME } from '@/store/modules/authentication/types';
import { CONFIG } from '@/config';
import {
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_DELETE_ALL,
  NOTIFICATIONS_GET_ALL,
  NOTIFICATIONS_GET_TOTAL
} from '@/store/modules/notifications/types';

@Component
export default class NotificationsButton extends Vue {
  public hasPopup: boolean = false;
  public parseToMoment = dateService.parseToMoment;

  $refs: {
    button: HTMLFormElement;
    content: HTMLFormElement;
  };

  @Getter(NOTIFICATIONS_GET_TOTAL)
  public total: number;

  @Getter(NOTIFICATIONS_GET_ALL)
  public notifications: Array<INotificationMessage>;

  @Getter(AUTH_GET_USERNAME)
  public userName: string;

  @Getter(AUTH_GET_TOKEN)
  public userToken: string;

  @Action(NOTIFICATIONS_DELETE)
  public deleteNotification: Function;

  @Action(NOTIFICATIONS_DELETE_ALL)
  public deleteAllNotification: Function;

  @Watch('total')
  public updateTotal(value: number) {
    if (value > 0) {
      this.createPopup();
    } else {
      this.hasPopup = false;
    }
  }

  public get topNotifications() {
    return _(this.notifications)
      .takeRight(3)
      .reverse()
      .value();
  }

  public removeNotifications(id: number): void {
    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/notification/read/${id}`)
      .then(() => {
        this.deleteNotification(id);
      })
      .catch(() => console.log('Failed to request server, try again.'));
  }

  public onRemove(notification: INotificationMessage) {
    this.removeNotifications(notification.id);
  }

  public mounted() {
    this.createPopup();
  }

  private createPopup() {
    if (this.total > 0 && !this.hasPopup) {
      ($(this.$refs.button) as any).popup({
        popup: this.$refs.content,
        inline: true,
        hoverable: true
      });
      this.hasPopup = true;
    }
  }
}
